import type { FC } from 'react';
import type { BasicBooking } from '../../../../../common/graphql/fragments/gql/BasicBooking';
import { type BookingFields, isHidden } from '../../../../../common/utils/bookingFields';
import { DetailsFieldCell } from '../../../../../common-ui/details/DetailsFieldCell';
import { HiddenFieldGate } from '../../../../../common-ui/HiddenFieldGate';
import { ColumnId } from '../../../../../gql/graphql';
import { CustomsClassificationField } from '../fields/CustomsClassificationField';
import { ImportExportField } from '../fields/ImportExportField';
import { ImportExportLabelIcon } from '../ImportExportLabelIcon';
import { BookingSection } from './BookingSection';

interface Props {
  booking: BasicBooking;
  disabled: boolean;
  fieldsToEnable: BookingFields;
  fieldsToShow: BookingFields;
}

export const ImportExportDetailsSection: FC<Props> = ({
  fieldsToEnable,
  booking,
  fieldsToShow,
  disabled,
}) => {
  const isDisabled = (field: ColumnId) => disabled || isHidden(fieldsToEnable, field);

  return (
    <BookingSection title={'Export/Import'}>
      <HiddenFieldGate hidden={isHidden(fieldsToShow, ColumnId.CustomsClassification)}>
        <DetailsFieldCell
          label={'UK customs procedure'}
          renderField={id => (
            <CustomsClassificationField
              id={id}
              disabled={isDisabled(ColumnId.CustomsClassification)}
            />
          )}
        />
      </HiddenFieldGate>
      <HiddenFieldGate hidden={isHidden(fieldsToShow, ColumnId.ExportReference)}>
        <DetailsFieldCell
          label={'Export'}
          contentLeft={
            <ImportExportLabelIcon
              booking={booking}
              name={'exportReference'}
              trackerCategory={'Details'}
            />
          }
          renderField={id => (
            <ImportExportField
              id={id}
              name={'exportReference'}
              booking={booking}
              disabled={isDisabled(ColumnId.ExportReference)}
            />
          )}
        />
      </HiddenFieldGate>
      <HiddenFieldGate hidden={isHidden(fieldsToShow, ColumnId.ImportReference)}>
        <DetailsFieldCell
          label={'Import'}
          contentLeft={
            <ImportExportLabelIcon
              booking={booking}
              name={'importReference'}
              trackerCategory={'Details'}
            />
          }
          renderField={id => (
            <ImportExportField
              id={id}
              name={'importReference'}
              booking={booking}
              disabled={isDisabled(ColumnId.ImportReference)}
            />
          )}
        />
      </HiddenFieldGate>
    </BookingSection>
  );
};
